import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import archiveRoutes from '@/router/routes/archive.js'
import assetRoutes from '@/router/routes/asset.js'

export default allRoutes.concat(
  publicRoutes,
  privateRoutes,
  archiveRoutes,
  assetRoutes
)